<div class="loading-container">
    <mat-spinner 
      customSpinner 
      [color]="color" 
      [diameter]="configLoading.diameter" 
      [strokeWidth]="configLoading.stroke" 
      class="spinner"
    ></mat-spinner>
      <span class="animate-pulse" *ngIf="disableLabel" 
        [style.color]="textColor" [style.fontSize]="configLoading.fontSize"
        > 
        Cargando... 
      </span>
    
  </div>
  